import React from 'react';
import { Link } from 'react-router-dom';
import { Routes } from '../../enums';
import style from './page404.module.css';

export function Page404() {
  return (
    <div className={style.root}>
      <h1>Page Not Found</h1>
      <h3>We can't find the page you're looking for.</h3>
      <p>
        You can either return to the previous page, visit our <Link to={Routes.Reports}>homepage</Link> or contact our{' '}
        <a href="https://www.grapecity.com/contact">support team</a>.
      </p>
    </div>
  );
}
